import validate from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  root: () => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/middleware/root.ts")
}